import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from '../common/interface';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private http : HttpClient
  ) { }

  getClients(status){
    let params : HttpParams = new HttpParams().set('active', status);
    return this.http.get<response>(environment.url + "clients", {params : params});
  }

  getClient(id, email){
    let params: HttpParams = new HttpParams().set('id', id).set("email", email);
    return this.http.get<response>(environment.url + "client", {params : params});
  }

  saveClient(client){
    return this.http.post<response>(environment.url + "clients", client);
  }

  updateClient(id, client){
    return this.http.put<response>(environment.url + "clients/"+id, client);
  }

  deleteClient(id){
    return this.http.delete<response>(environment.url + "client/"+id);
  }

}
